import React from 'react'
import { useSelector } from 'react-redux';
import CalibrationCertificateCreate from '../../components/calibrationcertificatedetailcomponents/CalibrationCertificateCreate';

function CalibrationCertificateCreates({renderPageContent}) {
  const headerName= useSelector(state => state.authendicationReducer.headerName); 

 
  if (headerName === 'Hospital Masters') {
    return (
        <>
            <CalibrationCertificateCreate renderPageContent={renderPageContent} />
        </>
    );
} else {
    // If headerName doesn't match, return null or any other desired behavior
    return null; // or any other fallback component
}
}
export default CalibrationCertificateCreates
